import type { MouseEvent } from 'react'
import { useCallback } from 'react'
import { OptionsMenuButton } from 'tripPlanner/assistant/components/HistoryItemOptions/OptionsMenuActions'

interface Props {
  label: string
  closeMenu: () => void
  onSelect: () => void
}

function AssistantHistoryItemMenuAction({ label, closeMenu, onSelect }: Props) {
  const handleClick = useCallback((event: MouseEvent) => {
    event.preventDefault()
    event.stopPropagation()
    closeMenu()
    onSelect()
  }, [closeMenu, onSelect])

  return (
    <OptionsMenuButton type="button" onClick={handleClick}>
      {label}
    </OptionsMenuButton>
  )
}

export default AssistantHistoryItemMenuAction
